var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base-common-content", {
    attrs: {
      "data-type": "base-agent-list",
      options: _vm.searchResults,
      "data-key": _vm.DATA_KEY,
      "use-search": _vm.useSearch,
      size: _vm.size,
      "show-options": _vm.showOptions,
      "is-searching": _vm.isSearching,
      "is-loading": _vm.isLoading,
    },
    scopedSlots: _vm._u(
      [
        {
          key: "search",
          fn: function () {
            return [
              _vm.useSearch
                ? _c(
                    "div",
                    { staticClass: "search" },
                    [
                      _vm.navigation === "results"
                        ? _c("base-search-input", {
                            attrs: {
                              search: _vm.searchOptions.search,
                              size: _vm.size,
                              "is-disabled": _vm.isLoading || _vm.isDisabled,
                            },
                            on: { "search-change": _vm.onSearchChange },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.useSearchOptions
                        ? _c(
                            "or-button",
                            {
                              attrs: {
                                "data-button": _vm.searchOptionsRole,
                                disabled: _vm.isLoading,
                              },
                              on: { click: _vm.onToggleSearchOptions },
                            },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(_vm.searchOptionsLabel) +
                                  "\n        "
                              ),
                              _c("or-icon", {
                                attrs: { icon: _vm.searchOptionsIcon },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "default",
          fn: function () {
            return [
              _vm.navigation === "options"
                ? _c("base-agent-search-options", {
                    attrs: {
                      options: _vm.searchOptions,
                      statuses: _vm.statuses,
                      "rule-groups": _vm.ruleGroups,
                      "is-disabled":
                        _vm.isLoading ||
                        _vm.isDisabled ||
                        !_vm.canChangeSearchOptions,
                    },
                    on: { "options-change": _vm.onSearchOptionsChange },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.navigation === "results" && _vm.noAgentsWarning
                ? _c("div", { staticClass: "no-agents-warning" }, [
                    _vm._v("\n      " + _vm._s(_vm.noAgentsWarning) + "\n    "),
                  ])
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        _vm.navigation === "results"
          ? {
              key: "append",
              fn: function () {
                return [_vm._t("options-append")]
              },
              proxy: true,
            }
          : null,
        {
          key: "option",
          fn: function (ref) {
            var option = ref.option
            return [
              _c("base-item", {
                attrs: {
                  avatar: _vm.avatar,
                  person: option,
                  title: _vm.getName(option),
                  description: option.email,
                  status: _vm.getStatusLabel(option),
                  "status-type": _vm.getStatusType(option),
                  size: _vm.size,
                  actions: _vm.actions,
                  "actions-type": _vm.actionsType,
                  "is-clickable": _vm.useDefaultAction,
                  "is-disabled": _vm.isDisabled,
                },
                on: {
                  "action-click": function ($event) {
                    return _vm.onActionClick({ option: option, key: $event })
                  },
                  "item-click": function ($event) {
                    return _vm.$emit("item-click", option)
                  },
                },
              }),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }